<script>
import ValidatesUsers from "./mixins/validates-users";
import ArchivesUsers from "./mixins/archives-users";
import toasts from "../../mixins/toasts";

let old;

export default Vue.extend({
  props: ["preset"],
  mixins: [ValidatesUsers, ArchivesUsers, toasts],
  data() {
    return {
      loading: false,
      user: _.merge(this.preset, {
        info: {},
        profile: {
          position: {},
          department: {},
        },
      }),
      modified: false,
    };
  },
  methods: {
    back: function () {
      window.history.back();
    },
    async submitAndClose() {
      await this.submit();
      setTimeout(() => {
        location = '/' + this.user.alias;
      }, 500);
    },
    async submit() {
      return new Promise((resolve, reject) => {
        if (!this.modified) {
          resolve();
          return;
        }

        if (!_.get(this.user.profile, "position.id")) {
          this.user.profile.position = {};
        }

        if (!_.get(this.user.profile, "department.id")) {
          this.user.profile.department = {};
        }

        this.$validator.validateAll().then((valid) => {
          if (valid) {
            this.loading = true;
            let loading = this.$loading.open();
            setTimeout(() => {
              axios
                .put("/api/users/" + this.user.id, this.user)
                .then((response) => {
                  let data = response.data;
                  if (!data.profile.position) {
                    data.profile.position = {};
                  }
                  if (!data.profile.department) {
                    data.profile.department = {};
                  }
                  this.user = data;
                  old = JSON.parse(JSON.stringify(this.user));
                  history.pushState(null, "", this.user.url + "/edit");
                  this.modified = false;
                  this.loading = false;
                  loading.close();
                  this.toast("success", "Изменения успешно сохранены");
                  resolve();
                })
                .catch((error) => {
                  switch (error.response.status) {
                    case 422: {
                      this.toast("error", "@validate");
                      break;
                    }
                    case 403: {
                      this.toast(
                        "warning",
                        "Сохранение пользователя с такими параметрами недоступно"
                      );
                      break;
                    }
                    default: {
                      this.toast("error", "@unexpected", error);
                    }
                  }
                  this.loading = false;
                  loading.close();
                  reject(error);
                });
            }, 2000);
          } else {
            this.modified = false;
            this.toast("error", "@invalid");
            reject();
          }
        });
      });
    },
  },
  created() {
    old = JSON.parse(JSON.stringify(this.user));
  },
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/users/Edit.vue